import {
  GetNotificationFeedRequest,
  GetNotificationFeedResponse,
  MarkNotificationsReadRequest,
  MarkNotificationSeenRequest,
} from '../interfaces/Notifications'
import { POST } from './Index'

export async function GetNotificationFeed(
  user_id: string,
  limit: number,
  offset: number
): Promise<GetNotificationFeedResponse> {
  return await POST<GetNotificationFeedRequest, GetNotificationFeedResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/get-notification-feed`,
    {
      user_id,
      limit,
      offset,
    }
  )
}

export async function MarkNotificationsRead(user_id: string): Promise<void> {
  return await POST<MarkNotificationsReadRequest, void>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/notifications/read`,
    {
      user_id,
    }
  )
}

export async function MarkNotificationSeen(user_id: string, group: string): Promise<void> {
  return await POST<MarkNotificationSeenRequest, void>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/notifications/seen`,
    {
      user_id,
      group,
    }
  )
}
